import { Box, Flex, Text, VStack } from "@chakra-ui/react";

type Format = "circle" | "square";

type Props = {
  legenda?: { title: string; color: string; format?: Format }[];
  children?: React.ReactNode;
};

export const SimpleLegendColorMapa = ({ legenda = [], children }: Props) => {
  const formatDefault: Format = "circle";

  legenda = legenda.map((x) => ({
    ...x,
    format: x.format || formatDefault
  }));

  return (
    <Box
      className="leaflet-control leaflet-bar leaflet-legend-custom"
      minW="9.375rem"
    >
      <Box
        bgColor="white"
        _dark={{ bgColor: "gray.900" }}
        px={4}
        py={3}
        borderRadius="md"
      >
        <Text
          fontSize="sm"
          color="gray.800"
          _dark={{ color: "gray.100" }}
          mb={2}
          fontWeight="medium"
        >
          Legenda
        </Text>
        <VStack alignItems="baseline">
          {legenda.map((x) => (
            <Flex key={x.title} gap="1" alignItems="center">
              <Box
                bgColor={x.color}
                h="3"
                w="3"
                borderRadius={x.format === "circle" ? "full" : "sm"}
                border="1px solid"
                borderColor="gray.300"
                _dark={{ borderColor: "gray.600" }}
              ></Box>
              <Text fontWeight="medium">{x.title}</Text>
            </Flex>
          ))}
          {children}
        </VStack>
      </Box>
    </Box>
  );
};
